import APIService from './APIService';

export default {
  getUltimaDataBase(empresaId) {
    return APIService.apiCall().get(`ais/get-ultima-data-base/${empresaId}`);
  }
};
